import client from './client';

export const marketplaceApi = {
  // Public browse (any authed user)
  browse: (params = {}) => client.get('/marketplace/listings/', { params }).then((r) => r.data),
  listing: (id) => client.get(`/marketplace/listings/${id}/`).then((r) => r.data),

  // FPO admin
  myListings: () => client.get('/marketplace/my-listings/').then((r) => r.data),
  myListing: (id) => client.get(`/marketplace/my-listings/${id}/`).then((r) => r.data),
  createListing: (data) => client.post('/marketplace/my-listings/', data).then((r) => r.data),
  updateListing: (id, data) => client.patch(`/marketplace/my-listings/${id}/`, data).then((r) => r.data),
  deleteListing: (id) => client.delete(`/marketplace/my-listings/${id}/`),

  // Listing images (FPO admin only)
  listListingImages: (listingId) =>
    client.get(`/marketplace/my-listings/${listingId}/images/`).then((r) => r.data),
  uploadListingImage: (listingId, file, { caption = '', orderIndex = 0 } = {}) => {
    const fd = new FormData();
    fd.append('image', file);
    if (caption) fd.append('caption', caption);
    fd.append('order_index', String(orderIndex));
    return client
      .post(`/marketplace/my-listings/${listingId}/images/`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data);
  },
  deleteListingImage: (imageId) =>
    client.delete(`/marketplace/my-listings/images/${imageId}/`),

  // Listing documents (FPO admin only)
  uploadListingDocument: (listingId, file, { docType = 'other', label = '' } = {}) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('doc_type', docType);
    if (label) fd.append('label', label);
    return client
      .post(`/marketplace/my-listings/${listingId}/documents/`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data);
  },
  deleteListingDocument: (docId) =>
    client.delete(`/marketplace/my-listings/documents/${docId}/`),

  // Crop progress events (FPO admin only)
  addProgressEvent: (listingId, { stage, occurredOn, notes = '', photo = null }) => {
    const fd = new FormData();
    fd.append('stage', stage);
    fd.append('occurred_on', occurredOn);
    if (notes) fd.append('notes', notes);
    if (photo) fd.append('photo', photo);
    return client
      .post(`/marketplace/my-listings/${listingId}/progress/`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data);
  },
  deleteProgressEvent: (eventId) =>
    client.delete(`/marketplace/my-listings/progress/${eventId}/`),

  // Sensor readings (FPO admin only)
  addSensorReading: (listingId, payload) =>
    client.post(`/marketplace/my-listings/${listingId}/sensor-readings/`, payload).then((r) => r.data),
  deleteSensorReading: (id) =>
    client.delete(`/marketplace/my-listings/sensor-readings/${id}/`),

  myOrders: () => client.get('/marketplace/my-orders/').then((r) => r.data),
  myOrder: (id) => client.get(`/marketplace/my-orders/${id}/`).then((r) => r.data),
  updateOrderStatus: (id, data) =>
    client.patch(`/marketplace/my-orders/${id}/status/`, data).then((r) => r.data),

  // Buyer
  placeOrder: (data) => client.post('/marketplace/place-order/', data).then((r) => r.data),
  buyerOrders: () => client.get('/marketplace/orders/').then((r) => r.data),
  buyerOrder: (id) => client.get(`/marketplace/orders/${id}/`).then((r) => r.data),
};
